import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Document, HubCompany } from 'Types/DocumentHubTypes';
import { DocumentHubState } from 'Types/GlobalTypes';
import { DocumentDeleteRequest, DocumentsRequest, UploadRequest } from 'Types/RequestBodies';
import _ from 'lodash';

export const initialState: DocumentHubState = {
  documents: [],
  documentsEnded: false,
  documentsLoaded: false,
  documentsLoading: false,
  sort: 'des',
  companyName: '',
  companyLogo: '',
  chatgptAllowed: false,
  uploaded: false,
  uploading: false,
  drawerOpen: false,
  deleteing: false,
  downloading: false,
  downloadUrl: '',
  drawerState: 'file',
};

const documentHubSlice = createSlice({
  name: 'documentHub',
  initialState,
  reducers: {
    getDocuments(state, action: PayloadAction<DocumentsRequest>) {
      state.documentsLoading = true;
      state.documentsEnded = false;
      if (action.payload.offset === 0) {
        state.documents = [];
        state.documentsLoaded = false;
      }
    },
    setDocuments(state, action: PayloadAction<Document[]>) {
      const { payload } = action;
      state.documents = state.documents.concat(payload);
      state.documentsLoading = false;
      if (!payload.length) {
        state.documentsEnded = true;
      }
      state.documentsLoaded = true;
    },
    setHubCompany(state, action: PayloadAction<HubCompany>) {
      const { companyLogo, companyName, chatgptAllowed } = action.payload;
      state.companyLogo = companyLogo;
      state.companyName = companyName;
      state.chatgptAllowed = chatgptAllowed;
    },
    toggleSort(state) {
      if (state.sort === 'asc') state.sort = 'des';
      else state.sort = 'asc';
      state.documentsLoaded = false;
      state.documents = [];
    },
    uploadDocument(state, action:PayloadAction<UploadRequest>) {
      state.uploaded = false;
      if (action.payload) {
        state.uploading = true;
      }
    },
    documentUploaded(state, action:PayloadAction<Document>) {
      state.uploaded = true;
      state.uploading = false;
      if (!_.isEmpty(action.payload)) {
        if (state.sort === 'asc') {
          state.documents = [...state.documents, action.payload];
        } else {
          state.documents = [action.payload, ...state.documents];
        }
      }
    },
    setDrawerOpen(state, action:PayloadAction<boolean>) {
      state.drawerOpen = action.payload;
      if (!action.payload) {
        state.drawerState = 'file';
      }
    },
    deleteDocument(state, action:PayloadAction<DocumentDeleteRequest>) {
      const { id } = action.payload;
      if (id) {
        state.deleteing = true;
        state.documents = state.documents.map((doc) => ({
          ...doc,
          deleting: doc.id === id,

        }));
      }
    },
    documentDeleted(state, action:PayloadAction<number>) {
      state.deleteing = false;
      const id = action.payload;
      if (id) {
        state.documents = state.documents.filter((doc) => doc.id !== id);
      }
    },
    downloadDocument(state, action:PayloadAction<string>) {
      const link = action.payload;
      if (link) {
        state.documents = state.documents.map((doc) => ({
          ...doc,
          downloading: doc.fileUrl === link,

        }));
        state.downloading = true;
        state.downloadUrl = link;
      }
    },
    documentDownloaded(state) {
      state.documents = state.documents.map((doc) => ({
        ...doc,
        downloading: false,
      }));
      state.downloading = false;
      state.downloadUrl = '';
    },
    setDrawerState(state, action: PayloadAction<string>) {
      state.drawerState = action.payload;
    },
  },
});

export const { actions, reducer, name: sliceKey } = documentHubSlice;
